import {
  AccountType,
  BeneficiaryType,
  ErrorType,
  WhitelistAddressType,
  WhitelistCapabilitiesType
} from 'data/types'

import * as AT from './actionTypes'
import * as bankTransfer from './BankTransfer/actions'
import { PaymentBanksActionType } from './BankTransfer/actions'
import { actions as paymentCurrenciesAcions } from './Currencies/slice'
import * as elegible from './Elegible/actions'
import { ElegiblePMsActionType } from './Elegible/actions'
import methods, { PaymentMethodsActionType } from './Methods/actions'
import * as payment from './Payment/actions'
import { PaymentActions } from './Payment/actions'
import * as submitDeposit from './SubmitDeposit/actions'
import { SubmitDepositActions } from './SubmitDeposit/actions'
import * as transactions from './Transactions/actions'
import { TransactionsActions } from './Transactions/actions'
import { actions as withdraw } from './Withdrawal/slice'
import * as withdrawFeesAndMin from './WithdrawFeesAndMin/actions'
import { WithdrawFeesAnMinActions } from './WithdrawFeesAndMin/actions'

export type FetchDataType = {
  type: typeof AT.FETCH_DATA
}
export type FetchAccountType = {
  payload: { currency: string }
  type: typeof AT.FETCH_ACCOUNT
}
export type FetchAccountsType = {
  type: typeof AT.FETCH_ACCOUNTS
}
export type AccountSuccessActionType = {
  payload: {
    account: AccountType
    currency: string
  }
  type: typeof AT.ACCOUNT_SUCCESS
}
export type AccountLoadingActionType = {
  payload: {
    currency: string
  }
  type: typeof AT.ACCOUNT_LOADING
}
export type AccountErrorActionType = {
  payload: {
    currency: string
    error: ErrorType
  }
  type: typeof AT.ACCOUNT_ERROR
}
export type FetchBeneficiariesType = {
  type: typeof AT.FETCH_BENEFICIARIES
}
export type BeneficiariesSuccessActionType = {
  payload: {
    beneficiaries: BeneficiaryType[]
  }
  type: typeof AT.BENEFICIARIES_SUCCESS
}
export type BeneficiariesLoadingActionType = {
  type: typeof AT.BENEFICIARIES_LOADING
}
export type BeneficiariesErrorActionType = {
  payload: {
    error: ErrorType
  }
  type: typeof AT.BENEFICIARIES_ERROR
}
export type RemoveBeneficiaryActionType = {
  payload: {
    id: string
  }
  type: typeof AT.REMOVE_BENEFICIARY
}
export type RemoveWhitelistAddressActionType = {
  payload: {
    code: string
    id: string
  }
  type: typeof AT.REMOVE_WHITELIST_ADDRESS
}

export type FetchWhitelistAddressesActionType = {
  type: typeof AT.FETCH_WHITELIST_ADDRESSES
}

export type SetWhitelistAddressesActionType = {
  payload: {
    addresses: WhitelistAddressType[]
  }
  type: typeof AT.SET_WHITELIST_ADDRESSES
}

export type SetWhitelistAddressesEnabledActionType = {
  payload: {
    enabled: boolean
  }
  type: typeof AT.SET_WHITELIST_ADDRESSES_ENABLED
}

export type SetWhitelistCapabilitiesActionType = {
  payload: {
    capabilities: WhitelistCapabilitiesType[]
  }
  type: typeof AT.SET_WHITELIST_CAPABILITIES
}

export type PaymentsActionType =
  | AccountSuccessActionType
  | AccountLoadingActionType
  | AccountErrorActionType
  | BeneficiariesSuccessActionType
  | BeneficiariesLoadingActionType
  | BeneficiariesErrorActionType
  | ElegiblePMsActionType
  | FetchAccountType
  | FetchAccountsType
  | FetchBeneficiariesType
  | FetchDataType
  | FetchWhitelistAddressesActionType
  | PaymentActions
  | PaymentBanksActionType
  | PaymentMethodsActionType
  | RemoveBeneficiaryActionType
  | RemoveWhitelistAddressActionType
  | SetWhitelistCapabilitiesActionType
  | SetWhitelistAddressesActionType
  | SetWhitelistAddressesEnabledActionType
  | SubmitDepositActions
  | TransactionsActions
  | WithdrawFeesAnMinActions

const fetchData = (): FetchDataType => ({
  type: AT.FETCH_DATA
})

const fetchAccount = (currency: string): FetchAccountType => ({
  payload: {
    currency
  },
  type: AT.FETCH_ACCOUNT
})
const fetchAccounts = (): FetchAccountsType => ({
  type: AT.FETCH_ACCOUNTS
})
const setAccountSuccess = (currency: string, account: AccountType): AccountSuccessActionType => ({
  payload: { account, currency },
  type: AT.ACCOUNT_SUCCESS
})
const setAccountLoading = (currency: string): AccountLoadingActionType => ({
  payload: { currency },
  type: AT.ACCOUNT_LOADING
})
const setAccountError = (currency: string, error: ErrorType): AccountErrorActionType => ({
  payload: { currency, error },
  type: AT.ACCOUNT_ERROR
})

const fetchBeneficiaries = (): FetchBeneficiariesType => ({
  type: AT.FETCH_BENEFICIARIES
})
const setBeneficiariesSuccess = (
  beneficiaries: BeneficiaryType[]
): BeneficiariesSuccessActionType => ({
  payload: { beneficiaries },
  type: AT.BENEFICIARIES_SUCCESS
})
const setBeneficiariesLoading = (): BeneficiariesLoadingActionType => ({
  type: AT.BENEFICIARIES_LOADING
})
const setBeneficiariesError = (error: ErrorType): BeneficiariesErrorActionType => ({
  payload: { error },
  type: AT.BENEFICIARIES_ERROR
})
const removeBeneficiary = (id: string): RemoveBeneficiaryActionType => ({
  payload: { id },
  type: AT.REMOVE_BENEFICIARY
})

const removeWhitelistAddress = (code: string, id: string): RemoveWhitelistAddressActionType => ({
  payload: { code, id },
  type: AT.REMOVE_WHITELIST_ADDRESS
})

const setWhitelistAddresses = (
  addresses: WhitelistAddressType[]
): SetWhitelistAddressesActionType => ({
  payload: { addresses },
  type: AT.SET_WHITELIST_ADDRESSES
})

const setWhitelistAddressesEnabled = (
  enabled: boolean
): SetWhitelistAddressesEnabledActionType => ({
  payload: { enabled },
  type: AT.SET_WHITELIST_ADDRESSES_ENABLED
})

const setWhitelistCapabilities = (
  capabilities: WhitelistCapabilitiesType[]
): SetWhitelistCapabilitiesActionType => ({
  payload: { capabilities },
  type: AT.SET_WHITELIST_CAPABILITIES
})

const fetchWhitelistAddresses = (): FetchWhitelistAddressesActionType => ({
  type: AT.FETCH_WHITELIST_ADDRESSES
})

export default {
  ...bankTransfer,
  currencies: paymentCurrenciesAcions,
  elegible,
  fetchAccount,
  fetchAccounts,
  fetchBeneficiaries,
  fetchData,
  fetchWhitelistAddresses,
  methods,
  payment,
  removeBeneficiary,
  removeWhitelistAddress,
  setAccountError,
  setAccountLoading,
  setAccountSuccess,
  setBeneficiariesError,
  setBeneficiariesLoading,
  setBeneficiariesSuccess,
  setWhitelistAddresses,
  setWhitelistAddressesEnabled,
  setWhitelistCapabilities,
  submitDeposit,
  transactions,
  withdraw,
  withdrawFeesAndMin
}
